module.exports = __webpack_public_path__ + "img/bs_plus_shop_soon_fr-FR-old.d3a456fd.jpg";